module.exports = __webpack_public_path__ + "static/media/redFlower.884728f8.png";